<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}} <v-btn class="primary--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <loading :active.sync="billingRunLoading" :is-full-page="true" color="grey"></loading>
    <!-- <v-toolbar flat color="white" class="pt-3">
      <v-flex>
        <v-btn v-show="setDate" color="primary" round @click="getBillingData= true">Get Billing Data</v-btn>
        <v-btn
          v-show="setDate"
          color="primary"
          round
          @click="getBillingTransactions()"
        >Get Transactions</v-btn>
        <v-btn color="primary" round v-show="billingData.length>0" @click="approve">Approve Billing</v-btn>
        <v-btn v-show="transactions.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="transactions"
            :fields="transactionExportFields"
            worksheet="export"
            :name="'Transaction_'+new Date().getTime()+'.xls'"
          >Export Transaction to Excel</download-excel>
        </v-btn>
        <v-btn v-show="billingData.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="billingData"
            :fields="exportFields"
            worksheet="export"
            :name="'Billing_'+new Date().getTime()+'.xls'"
          >Export to Excel</download-excel>
        </v-btn>
      </v-flex>
    </v-toolbar> -->
    <v-layout justify-center align-center v-if="billingData.length>0">
      <v-flex>
        <h3 class="grey--text">Once-Off Billed: <span>{{billingData.reduce((a, b) => +a + +b.onceOff, 0)|currency}}</span></h3>
      </v-flex>
      <v-flex>
        <h3 class="grey--text">Recurring Billed: <span >{{billingData.reduce((a, b) => +a + +b.prorata, 0)|currency}}</span></h3>
      </v-flex>
      <v-flex>
        <h3 class="grey--text">Total Billed: <span >{{billingData.reduce((a, b) => +a + +b.prorata, 0)+billingData.reduce((a, b) => +a + +b.onceOff, 0)|currency}}</span></h3>
      </v-flex>
    </v-layout>
    <v-flex>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :pagination.sync="pagination"
        :items="billingData"
        :rows-per-page-items="[25, 50, 100, 250]"
        item-key="id"
        align-center
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon @click="edit(props.item)">edit</v-icon>
          </td> -->
          <!-- <td class="text-xs-center" v-if="props.item.isActive">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td> -->
          <td class="text-xs-center">{{props.item.circuitNumber}}</td>
          <td class="text-xs-center">{{props.item.packagesIsp.customerOrganisation.name}}</td>
          <td class="text-xs-center">{{props.item.location.unitNo}}</td>
          <td class="text-xs-center">{{props.item.location.locationNetwork.name}}</td>
          <td class="text-xs-center">{{props.item.packagesIsp.packagesFno.packageCode}}</td>
          <td
            class="text-xs-center"
          >{{props.item.packagesIsp.packagesFno.packageBasePrice | currency}}</td>
          <td class="text-xs-center">{{formatDate(props.item.initialActivation)}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.fnoDeactivationDate!==null"
          >{{formatDate(props.item.fnoDeactivationDate)}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{formatDate(new Date(props.item.startDate))}}</td>
          <td class="text-xs-center">{{formatDate(new Date(props.item.endDate))}}</td>
          <td class="text-xs-center">{{props.item.onceOff|currency}}</td>
          <td class="text-xs-center">{{props.item.prorata|currency}}</td>
        </template>
        <!-- Custom Row count and Paging text -->
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
  </div>
</template>
<script>
import dateformat from "dateformat";
import Api from "@/services/Api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    loading: Loading
  },
  props: ["billingData", "layertwobilling", "runBilling"],
  data() {
    return {
      picker: new Date().toISOString().substr(0, 7),
      date: "",
      text: "",
      snackbar: false,
      y: "top",
      search: "",
      billingRunLoading: false,
      getBillingData: false,
      allowedDates: [],
      networkTotals: [],
      setDate: null,
      startDay: null,
      endDay: null,
      showBillingData: false,
      billingBatchNumber: "",
      lastDay: "",
      firstDay: "",
      realDate: "",
      pagination: {},
      activationDates: [],
      transactions: [],
      totalRecurringCalculation: [],
      totalOnceOffCalculation: [],
      newCustomers: [],
      cancelledCustomers: [],
      allTransactions: [],
      upgradedCustomers: [],
      downgradedCustomers: [],
      billedDays: "",
      daysInCurrentMonth: "",
      fnoActivationDate: "",
      ispActivationDate: "",
      fnoDeactivationDate: "",
      ispDeactivationDate: "",
      startDate: "",
      endDate: "",
      filterStartDate: "",
      filterEndDate: "",
      allNetworks: [],
      transactionPost: [],
      unitsPassed: 0,
      unitsConnected: 0,
      billedCustomers: 0,
      newApplications: 0,
          newCustomers: 0,
          upgradedCustomers: 0,
          downgradedCustomers: 0,
          cancelledCustomers: 0,
          activationsCompleted: 0,
          passiveInstallsCompleted: 0,
          activeInstallsCompleted: 0,
          fibreRepairsCompleted: 0,
          equipmentReplacementsCompleted: 0,
          apiUrl: null,
          apiToken: null,
      transactionExportFields: {
        id: "id",
        description: "description",
        transactionType: "transactionType",
        customer: "customer.name",
        supplier: "supplier.name",
        location: "location.unitNo",
        network: "locationNetwork.name",
        node: "locationNode.name",
        serviceAccountId: "serviceAccountId",
        amount: "amount"
      },
      exportFields: {
        id: "id",
        circuitNumber: 'circuitNumber',
        node: "location.locationNetwork.locationNode.name",
        network: "location.locationNetwork.name",
        subNetwork: {
          callback: value => {
            if(value.location.locationNetworkSubComplexId !== null){
            return value.location.locationNetworkSubComplex.subComplexName;
            } else {
              return value.location.subComplexName
            }
          }
        },
        unit: "location.locationDescription",
        // {
        //   callback: value => {
        //     if (value.location.locationNetworkSubComplexId !== null) {
        //       return (
        //         value.location.unitNo +
        //         " " +
        //         value.location.locationNetworkSubComplex.subComplexName
        //       );
        //     } else {
        //       return value.location.unitNo;
        //     }
        //   }
        // },
        ispName: "packagesIsp.customerOrganisation.name",
        pppoeUsername: "pppoeUsername",
        fnoPackage: "packagesIsp.packagesFno.packageCode",
        downloadMbps: "packagesIsp.packagesFno.speedProfile.downloadMbps",
        initialActivation: {
          callback: value => {
            return this.formatDate(value.initialActivation);
          }
        },
        ispActivation: {
          callback: value => {
            return this.formatDate(value.ispActivationDate);
          }
        },
        ispDeactivation: {
          callback: value => {
            return this.formatDate(value.ispDeactivationDate);
          }
        },
        fnoActivation: {
          callback: value => {
            return this.formatDate(value.fnoActivationDate);
          }
        },
        fnoDeactivation: {
          callback: value => {
            return this.formatDate(value.fnoDeactivationDate);
          }
        },
        fnoPackagePrice: {
          callback: value => {
            if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.residentialLineRentalValue
              );
            } else if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.businessLineRentalValue
              );
            } else {
              return value.packagesIsp.packagesFno.packageBasePrice;
            }
          }
        },
        billedFrom:  {
          callback: value => {
            return this.formatDate(value.startDate);
          }
        },
        billedTo: {
          callback: value => {
            return this.formatDate(value.endDate);
          }
        },
        "Data Activation Fee": 'onceOff',
        "VAS Billed": 'prorata'
          
        
      },
      headers: [
        // {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Circuit Number",
          align: "center",
          value: "circuitNumber"
        },
        {
          text: "ISP Name",
          align: "center",
          value: "packagesIsp.customer.name"
        },
        {
          text: "Unit No",
          align: "center",
          value: "location.unitNo"
        },
        {
          text: "Network",
          align: "center",
          value: "location.locationNetwork.name"
        },

        {
          text: "FNO Package Code",
          align: "center",
          value: "packagesIsp.packagesFno.packageCode"
        },
        {
          text: "FNO Package price",
          align: "center",
          value: "packagesIsp.packagesFno.packageBasePrice"
        },
        {
          text: "Initial Account Activation",
          align: "center",
          value: "initialActivation"
        },
        {
          text: "Account Deactivation",
          align: "center",
          value: "fnoDeactivationDate"
        },
        {
          text: "Billing Start",
          align: "center",
          value: "startDate"
        },
        {
          text: "Billing End",
          align: "center",
          value: "endDate"
        },
        {
          text: "Once-Off Fee Billed ex VAT",
          align: "center",
          value: 'onceOff'
        },
        {
          text: "Recurring VAS Fee Billed ex VAT",
          align: "center",
          value: 'prorata'
        }
      ]
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    runBilling(value){
      console.log(value)
      if(value == true && this.billingData.length>0){
        this.approve()
      }
    },
    getBillingData(value) {
      if (this.setStart !== null && this.setEnd !== null) {
        const route = {
          name: this.$route.name
        };
        route.query = { billingDate: this.setDate };
        this.$router.push(route);
      }
      this.showBillingData = true;
      this.getBillingData = false;
    },
    setDate(value) {
      this.showBillingData = false;
      // (this.startDay = new Date(this.setDate)),
      let selectedDate = new Date(this.setDate);
      (this.startDay = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth() - 1,
        26
      )),
        (this.endDay = new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth() + 1,
          25
        ));
      let date = new Date(
        this.startDay.getFullYear(),
        this.startDay.getMonth(),
        0
      );
    }
  },
  computed: {},
  methods: {
    initialize() {
      this.getAllowedMonths();
    },
    async getBillingTransactions() {
      let date = new Date(this.setDate);
      await Api()
        .get("/transactions/allbyDate", {
          params: {
            billingDate: this.setDate
          }
        })
        .then(response => {
          this.transactions = response.data;
        });
    },
    getAllowedMonths() {
      let startDate = "2017-06";
      let today = new Date();
      let endDate = today.getFullYear() + "-" + (today.getMonth() + 1);
      // endDate=endDate.toString();
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      this.allowedDates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          this.allowedDates.push([i, displayMonth].join("-"));
        }
      }
    },
    edit(item) {
      this.editedItem = Object.assign({}, item);
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    getStart(date1, date2) {
      this.date = new Date();
      date1 = new Date(date1);
      date2 = new Date(date2);
      this.firstDay = new Date(
        this.date.getFullYear(),
        this.date.getMonth(),
        0 + 1,
        2
      );
      if (this.firstDay < date1 || this.firstDay < date2) {
        if (date1 > date2) {
          this.startDate = date1;
          return this.startDate;
        } else {
          this.startDate = date2;
          return this.startDate;
        }
      } else {
        this.startDate = this.firstDay;
        return this.startDate;
      }
    },
    getEnd(date1, date2) {
      this.date = new Date();
      let setDate = new Date(this.setDate);
      this.lastDay = new Date(setDate.getFullYear(), setDate.getMonth() + 1, 0);
      date1 = new Date(date1);
      date2 = new Date(date2);
      if (date1 > date2) {
        this.realDate = date2;
      } else if (date2 > date1) {
        this.realDate = date1;
      } else {
        this.realDate = date1;
      }
      if (this.lastDay < this.realDate) {
        this.endDate = this.lastDay;
        return this.endDate;
      } else if (this.realDate.getFullYear() !== 1970) {
        this.endDate = this.realDate;
        return this.endDate;
      } else {
        this.endDate = this.lastDay;
        return this.endDate;
      }
    },
    onceOff(item) {
      // console.log(item)
      this.date = new Date();
      item.initialActivation = new Date(item.initialActivation);
      if (
        ((item.initialActivation.getMonth() === this.date.getMonth() &&
          item.initialActivation.getYear() === this.date.getYear() &&
          item.initialActivation.getDate() <= 25) ||
          (item.initialActivation.getMonth() === this.date.getMonth() - 1 &&
            item.initialActivation.getYear() === this.date.getYear() &&
            item.initialActivation.getDate() > 25)) &&
        item.isChange === false
      ) {
        return item.location.locationNetwork.activationFeeAmount;
      } else {
        return 0;
      }
    },
    getDates(item) {
      if (new Date(item.initialActivation) >= new Date(this.startDay)) {
        this.startDate = new Date(item.initialActivation);
      } else {
        this.startDate = new Date(this.startDay);
      }

      if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate === null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      } else if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate !== null &&
        new Date(item.ispDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.ispDeactivationDate);
      }
      return this.startDate, this.endDate;
    },
    calcuateRecurringBills(item) {
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.initialActivation) >= new Date(this.startDay)) {
        this.startDate = new Date(item.initialActivation);
      } else {
        this.startDate = new Date(this.startDay);
      }
      if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate === null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      } else if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate !== null &&
        new Date(item.ispDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.ispDeactivationDate);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate !== null
      ) {
        if(new Date(item.fnoDeactivationDate) > new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) > new Date(this.endDay)){
          this.endDate = new Date(this.endDay);
        }
        else if (
          new Date(item.fnoDeactivationDate) >=
          new Date(item.ispDeactivationDate)
        ) {
          this.endDate = new Date(item.fnoDeactivationDate);
        } else {
          this.endDate = new Date(item.ispDeactivationDate);
        }
      }
      let setDate = new Date(this.setDate);
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / 86400000
      );
      this.startDate = new Date(this.startDate);
      this.endDate = new Date(this.endDate);
      let billedAmount = item.packagesIsp.packagesFno.packageBasePrice;
      this.billedDays = Math.round(
        Math.abs(this.endDate.getTime() - this.startDate.getTime()) / 86400000
      );
      if (item.location.locationNetwork.lineRentalIncluded&&item.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential') {
        billedAmount =
          billedAmount - item.location.locationNetwork.residentialLineRentalValue;
      } else if (item.location.locationNetwork.lineRentalIncluded&&item.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business') {
        billedAmount =
          billedAmount - item.location.locationNetwork.businessLineRentalValue;
      }

      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    },
    recurring(item) {
      this.date = new Date();
      this.daysInCurrentMonth = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        0
      ).getDate();
      this.startDate = new Date(this.startDate);
      this.endDate = new Date(this.endDate);
      if (
        this.startDate.getMonth() === this.endDate.getMonth() &&
        this.startDate.getYear() === this.endDate.getYear()
      ) {
        this.billedDays = this.endDate.getDate() - this.startDate.getDate() + 1;
        return (
          Math.round(
            (this.billedDays / this.daysInCurrentMonth) *
              item.packagesIsp.packagesFno.packageBasePrice *
              100
          ) / 100
        );
      } else {
        let daysInPrevMonth = new Date(
          this.date.getFullYear(),
          this.date.getMonth(),
          0
        ).getDate();
        this.billedDays =
          this.endDate.getDate() + (daysInPrevMonth - this.startDate.getDate());
        return (
          Math.round(
            (this.billedDays / this.daysInCurrentMonth) *
              item.packagesIsp.packagesFno.packageBasePrice *
              100
          ) / 100
        );
      }
    },
    async completeBillingRun() {
      this.approve(),
        this.approveBas(),
        this.networkBillingRun(),
        this.nodeBillingRun();
    },
    async createXeroInvoices(){
      let lineItems=[]
      this.snackbar=true
      this.text="Creating Xero Invoices"
      let count = 0
      await Api()
        .get('/transactions/globalByDate',{
          params:{
            billingDate: this.$route.query.billingDate
          }
        })
        .then(async response=>{
            let allDateTransactions=response.data
            let date = new Date(this.$route.query.billingDate)
            let month = date.toLocaleString('default', { month: 'long' }) + ' '+date.getFullYear();
            
            for (let i=0; i< this.layertwobilling.length;i++){
              var helper = {};
              let billingSummary=[];
              let id = this.layertwobilling[i].organisationId
              let transactions =[]
              transactions = await allDateTransactions.filter(function(el){
                return el.customerOrganisationId === id
              })
            billingSummary = await transactions.reduce(function(r, o) {
              let key = o.xeroCode;
              if(!helper[key]) {
                helper[key] = Object.assign({}, o);
                r.push(helper[key]);
              } else {
                helper[key].amount += o.amount;
              }
              return r;
            }, []);
            this.layertwobilling[i].invoiceItems=[]
            for (let b=0; b<billingSummary.length;b++){
              this.layertwobilling[i].invoiceItems.push({Description: billingSummary[b].description, AccountCode: billingSummary[b].xeroCode, Quantity: 1, UnitAmount: billingSummary[b].amount})
            }
            // console.log(billingSummary)
            await Api()
            .post('/xero/invoice',{
                  Type: "ACCREC",
                  Contact: { 
                    ContactID: this.layertwobilling[i].xeroContactId
                  },
                  Reference: month,
                  Date: new Date(date.getFullYear(), date.getMonth(), 26),
                  DueDate: new Date(date.getFullYear(), date.getMonth() + 1, 1),
                  LineAmountTypes: "Exclusive",
                  LineItems: this.layertwobilling[i].invoiceItems
            }).then(response=>{
              console.log(response)
            })
            count += 1
            }
            
        })
        this.snackbar=true
            this.text="Successfully Generated "+ count + ' Invoices!'
            console.log(new Date())
      this.billingRunLoading = false;
    },
    async fibreFarmerBilling(date){
      this.snackbar=true
      this.text="Generating Fibre Farmer Billing"
      await Api()
      .get('/fibrefarmerlocationNetwork')
      .then(async response=>{
        let postData =[]
        let nodeTotals = []
        let locationNodes=[]
        let locationNodeIdentifier=[]
        let orgs =[]
        for (let i=0; i<response.data.length;i++){
          await Api()
          .get('/transactions/subOrg/network/'+response.data[i].customerOrganisationId+'/'+response.data[i].locationNetworkId,{
            params:{
              billingDate: date
            }
          })
          .then(async result=>{
            for (let a=0; a<result.data.length;a++){
              if(!nodeTotals.includes(result.data[a])){
                await nodeTotals.push(result.data[a])
              }
              if(!locationNodeIdentifier.includes(result.data[a].organisationId+'-'+result.data[a].locationNodeId)){
                await locationNodeIdentifier.push(result.data[a].organisationId+'-'+result.data[a].locationNodeId)
                await locationNodes.push({organisationId: result.data[a].organisationId, locationNodeId: result.data[a].locationNodeId})
                if(!orgs.includes(result.data[a].organisationId)){
                  await orgs.push(result.data[a].organisationId)
                }
              }
            }
            if(result.data.length>0){
              await this.calculateNetworkTotals(result.data)
            }
            
          })
        }
        for (let b=0; b<orgs.length;b++){
          let nodeTransactions=[]
          let customersCompleted =[]
          if(!customersCompleted.includes(orgs[b])){
            customersCompleted.push(orgs[b])
            let customerOrgId=orgs[b]
            let customerNodes = await locationNodes.filter(function(el){
              return el.organisationId===customerOrgId
            })
            for (let c=0; c<customerNodes.length;c++){
              await Api()
          .get('/transactions/subOrg/node/'+customerOrgId+'/'+customerNodes[c].locationNodeId,{
            params:{
              billingDate: date
            }
          }).then(async result=>{
            if(result.data.length>0){
              await this.calculateNodeTotals(result.data)
            }
          })
            }
          }
        }
        this.createXeroInvoices()
      })
      
    },
    async calculateGlobalTotals(transactions) {
      console.log("Calculate Global Totals");
      let setDate = new Date(this.setDate);
      var helper = {};
      var result = transactions.reduce(function(r, o) {
        var key = o.description + "-" + o.customerOrganisationId+ "-" + o.supplierOrganisationId;

        if (!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }
  
        return r;
      }, []);
      for (let i = 0; i < result.length; i++) {
        await this.transactionPost.push({
          date: result[i].date,
          description: result[i].description,
          xeroCode: result[i].xeroCode,
          amount: result[i].amount,
          isRecurring: result[i].isRecurring,
          organisationId: result[i].organisationId,
          supplierOrganisationId: result[i].supplierOrganisationId,
          customerOrganisationId: result[i].customerOrganisationId,
          transactionType: result[i].transactionType,
          locationId: null,
          locationNetworkId: null,
          locationNodeId: null,
          batchNumber: this.billingBatchNumber.toString(),
          switchingCentreId: null,
          loanAccountCustomerId: null,
          upstreamTransactionId: null,
          isActive: true,
          isDeleted: false
        });
      }
      await Api()
      .post('/transactions/bulk',{
        batch: this.transactionPost
      }).then(async response=>{
        if(response.status===200){
          this.transactionPost=[]
        }
      })
    },
    async globalReport(date) {
      console.log("Global Report");
      this.snackbar=true
      this.text="Calculating Global Totals"
      let setDate = new Date(this.setDate);
      await Api()
        .get("/transactions/allNodesByDate", {
          params: {
            billingDate: date
          }
        })
        .then(async response => {
          console.log(response.data)
          await this.calculateGlobalTotals(response.data);
          this.snackbar=true
          this.text="Layer 2 Billing"
          let transactionPost=[]
      for (let a =0; a< this.layertwobilling.length;a++){
        await transactionPost.push({
          date: date,
          description: "95th Percentile Layer 2 Usage: From "+this.formatDate(this.layertwobilling[a].from) +' To ' + this.formatDate(this.layertwobilling[a].to),
          xeroCode: 202,
          amount: this.layertwobilling[a].layerTwoUsage*this.layertwobilling[a].layerTwoRate,
          isRecurring: true,
          organisationId: this.$store.state.currentOrg.org.id,
          supplierOrganisationId: null,
          customerOrganisationId: this.layertwobilling[a].organisationId,
          transactionType: 'Sales',
          locationId: null,
          batchNumber: this.billingBatchNumber.toString(),
          locationNetworkId: null,
          locationNodeId: null,
          switchingCentreId: null,
          loanAccountCustomerId: null,
          upstreamTransactionId: null,
          isActive: true,
          isDeleted: false
        });
        
        
      }
      await Api()
      .post('/transactions/bulk',{
        batch: transactionPost
      }).then(response=>{
        if(response.status===200){
          transactionPost=[]
        }
      })
        });
        await this.fibreFarmerBilling(date)
        
    },
    async calculateMonthlyStatistics(transactions, networkObject, date){
      this.snackbar=true
      this.text="Calculating Monthly Statistics"
       this.unitsConnected=0
       this.billedCustomers=0
       this.newApplications=0
       this.newCustomers=0
       this.upgradedCustomers=0
       this.downgradedCustomers=0
       this.cancelledCustomers=0
       this.activationsCompleted=0
       this.migrationsCompleted=0
       this.passiveInstallsCompleted=0
       this.activeInstallsCompleted=0
       this.fibreRepairsCompleted=0
       this.equipmentReplacementsCompleted=0
      let setDate = new Date(this.setDate);
      var helper = {};
      var result = transactions.reduce(function(r, o) {
        var key = o.transactionType+'-'+o.isRecurring;

        if (!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      // let date = null
      let recurringSalesTotal = 0
      let onceOffSalesTotal =0
      let cosTotal = 0
      let expensesTotal = 0
      for (let i = 0; i < result.length; i++) {
        // date = result[i].date
        if(result[i].transactionType==='Sales'&&result[i].isRecurring===true){
          recurringSalesTotal = result[i].amount
        }
        if(result[i].transactionType==='Sales'&&result[i].isRecurring===false){
          onceOffSalesTotal = result[i].amount
        }
        if(result[i].transactionType==='Cost of Sales'){
          cosTotal = result[i].amount
        }
        if(result[i].transactionType==='Expense'){
          expensesTotal = result[i].amount
        }
      };

      this.unitsConnected = networkObject.locations.filter(function (el) {
  return el.fibrePulled === true
});

await Api()
      .get('/serviceAccounts/billing/byNetwork/'+networkObject.id,{
        params:{
          billingDate: date
        }
      }).then(response=>{
        this.billedCustomers=response.data
      });
      await Api()
      .get('/serviceAccountsAuditLog/byNetwork/'+networkObject.id,{
        params:{
          date: date
        }
      }).then(response=>{
        // let setDate = new Date(this.setDate);
      for (let i = 0; i < response.data.length; i++) {
        if(response.data[i].requestType==='Upgrade'&&response.data[i].status==='Resolved'){
          this.upgradedCustomers = this.upgradedCustomers +1
        }
        if(response.data[i].requestType==='Downgrade'&&response.data[i].status==='Resolved'){
          this.downgradedCustomers = this.downgradedCustomers +1
        }
        if(response.data[i].requestType==='Termination'&&response.data[i].status==='Resolved'){
          this.terminatedCustomers = this.terminatedCustomers +1
        }
        if(response.data[i].requestType==='Migration'&&response.data[i].status==='Resolved'){
          this.migrationsCompleted = this.migrationsCompleted+1
        }
      };})
      await Api().post("/statistics", {
          date: date,
          recurringSales: recurringSalesTotal,
          onceOffSales: onceOffSalesTotal,
          costOfSales: cosTotal,
          expenses: expensesTotal,
          averageSalesPerUnit: recurringSalesTotal/this.unitsConnected.length,
          averageCosPerUnit: cosTotal/this.unitsConnected.length,
          averageExpensePerUnit: expensesTotal/this.unitsConnected.length,
          unitsPassed: networkObject.locations.length,
          unitsConnected: this.unitsConnected.length,
          billedCustomers: this.billedCustomers.length,
          newApplications: this.newApplications,
          newCustomers: this.newCustomers,
          upgradedCustomers: this.upgradedCustomers,
          downgradedCustomers: this.downgradedCustomers,
          cancelledCustomers: this.cancelledCustomers,
          activationsCompleted: this.activationsCompleted,
          migrationsCompleted: this.migrationsCompleted,
          passiveInstallsCompleted: this.passiveInstallsCompleted,
          activeInstallsCompleted: this.activeInstallsCompleted,
          fibreRepairsCompleted: this.fibreRepairsCompleted,
          equipmentReplacementsCompleted: this.equipmentReplacementsCompleted,
          locationNetworkId: networkObject.id,
          locationNodeId: networkObject.locationNodeId,
          switchingCentreId: networkObject.locationNode.switchingCentreId,
          isActive: true,
          isDeleted: false
        });
    },
    async calculateNodeTotals(transactions) {
      console.log("Calculate Node Totals");
      let setDate = new Date(this.setDate);
      var helper = {};
      var result = transactions.reduce(function(r, o) {
        var key = o.description + "-" + o.customerOrganisationId+ "-" + o.supplierOrganisationId;

        if (!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      console.log('Node Totals', result)
      for (let i = 0; i < result.length; i++) {
        let date = result[i].date
        await this.transactionPost.push({
          date: result[i].date,
          description: result[i].description,
          xeroCode: result[i].xeroCode,
          amount: result[i].amount,
          isRecurring: result[i].isRecurring,
          organisationId: result[i].organisationId,
          supplierOrganisationId: result[i].supplierOrganisationId,
          customerOrganisationId: result[i].customerOrganisationId,
          transactionType: result[i].transactionType,
          locationId: null,
          batchNumber: this.billingBatchNumber.toString(),
          locationNetworkId: null,
          locationNodeId: result[i].locationNodeId,
          switchingCentreId: result[i].switchingCentreId,
          loanAccountCustomerId: null,
          upstreamTransactionId: null,
          isActive: true,
          isDeleted: false
        });
      }
      
      await Api()
      .post('/transactions/bulk',{
        batch: this.transactionPost
      }).then(response=>{
        if(response.status===200){
          this.transactionPost=[]
        }
      })
    },
    async nodeBillingRun(date) {
      console.log("Node Billing Run");
      this.snackbar=true
      this.text="Calculating Node Totals"
      let setDate = new Date();
      this.allTransactions = [];
      await Api()
        .get("/locationNodes/active")
        .then(async response => {
          for (let y = 0; y < response.data.length; y++) {
            await Api()
              .get("/transactions/byNodeByDate/" + response.data[y].id, {
                params: {
                  billingDate: date
                }
              })
              .then(async result => {
                this.allTransactions.push(result.data);
                await this.calculateNodeTotals(result.data)
                });
                await Api()
              .get('/locationNodeRecurringTransactions/byNode/'+response.data[y].id)
              .then(async response2=>{
                if(response2.data.length>0){
                  let allTransactions=[]
                  for (let a=0; a< response2.data.length;a++){
                    await allTransactions.push({
                      date: date,
                        description: response2.data[a].description,
                        xeroCode: response2.data[a].xeroCode,
                        amount: response2.data[a].amount,
                        isRecurring: true,
                        organisationId: response2.data[a].organisationId,
                        customerOrganisationId: response2.data[a].customerOrganisationId,
                        supplierOrganisationId: response2.data[a].supplierOrganisationId,
                        isRecurring: true,
                        transactionType: response2.data[a].transactionType,
                        batchNumber: this.billingBatchNumber.toString(),
                        locationId: null,
                        locationNetworkId: null,
                        locationNodeId: response2.data[a].locationNodeId,
                        upstreamTransactionId: null,
                        isActive: true,
                        isDeleted: false
                    })
                  }
                  await Api()
      .post('/transactions/bulk',{
        batch: allTransactions
      })
                }
              })
              
          }
        });

      this.globalReport(date)
    },
    async calculateNetworkTotals(transactions) {
      console.log("Calculate Network Totals");
      let setDate = new Date(this.setDate);
      var helper = {};
      var result = transactions.reduce(function(r, o) {
        var key = o.description + "-" + o.customerOrganisationId+ "-" + o.supplierOrganisationId;

        if (!helper[key]) {
          helper[key] = Object.assign({}, o); // create a copy of o
          r.push(helper[key]);
        } else {
          helper[key].amount += o.amount;
        }

        return r;
      }, []);
      console.log('Network Totals', result)
      for (let i = 0; i < result.length; i++) {
        await this.transactionPost.push({
          date: result[i].date,
          description: result[i].description,
          xeroCode: result[i].xeroCode,
          amount: result[i].amount,
          isRecurring: result[i].isRecurring,
          organisationId: result[i].organisationId,
          supplierOrganisationId: result[i].supplierOrganisationId,
          customerOrganisationId: result[i].customerOrganisationId,
          transactionType: result[i].transactionType,
          locationId: null,
          batchNumber: this.billingBatchNumber.toString(),
          locationNetworkId: result[i].locationNetworkId,
          locationNodeId: result[i].locationNodeId,
          switchingCentreId: result[i].switchingCentreId,
          loanAccountCustomerId: null,
          upstreamTransactionId: null,
          isActive: true,
          isDeleted: false
        })
      }
      await Api()
      .post('/transactions/bulk',{
        batch: this.transactionPost
      }).then(response=>{
        if(response.status===200){
          this.transactionPost=[]
        }
      })
    },
    async getLayer2Data(){
      await Api()
      .get('/integrations/byName/LibreNMS')
      .then(response=>{
        this.apiUrl=response.data.apiUrl
        this.apiToken=response.data.token
        Api()
        .get('/libre/allBills',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        }).then(response=>{
          console.log(response)
        })
        Api()
        .get('/libre/billHistory/20',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        })
        .then(response=>{
          console.log(response)
        })
        Api()
        .get('/libre/billGraph/20',{
          params: {
            apiUrl: this.apiUrl,
            apiToken: this.apiToken
          }
        })
        .then(response=>{
          console.log(response)
        })
      })
    },
    async networkBillingRun(date) {
      console.log("Network Billing");
      this.snackbar=true
      this.text="Calculating Network Totals"
      let setDate = new Date(date);
      // Post Transactions on Network Level
      await Api()
        .get("/locationNetworks/basicActive")
        .then(async response => {
          this.allNetworks = response.data;
          for (let i = 0; i < this.allNetworks.length; i++) {
            await Api()
              .get("/transactions/byNetworkByDate/" + this.allNetworks[i].id, {
                params: {
                  billingDate: date
                }
              })
              .then(async response => {
                let networkTransactions = response.data;
                await this.calculateNetworkTotals(networkTransactions);
                // await this.calculateMonthlyStatistics(response.data, this.allNetworks[i], date)
                // await this.fibreFarmerBilling(networkTransactions)
              });
              await Api()
              .get('/locationNetworkRecurringTransactions/byNetwork/'+this.allNetworks[i].id)
              .then(async response=>{
                if(response.data.length>0){
                  let allTransactions=[]
                  for (let a=0; a< response.data.length;a++){
                    await allTransactions.push({
                      date: date,
                        description: response.data[a].description,
                        xeroCode: response.data[a].xeroCode,
                        amount: response.data[a].amount,
                        isRecurring: true,
                        organisationId: this.$store.state.currentOrg.org.id,
                        customerOrganisationId: response.data[a].customerOrganisationId,
                        supplierOrganisationId: response.data[a].supplierOrganisationId,
                        transactionType: response.data[a].transactionType,
                        batchNumber: this.billingBatchNumber.toString(),
                        locationId: null,
                        locationNetworkId: this.allNetworks[i].id,
                        locationNodeId: this.allNetworks[i].locationNodeId,
                        switchingCentreId: this.allNetworks[i].locationNode
                          .switchingCentreId,
                        upstreamTransactionId: null,
                        isActive: true,
                        isDeleted: false
                    })
                  }
                  await Api()
      .post('/transactions/bulk',{
        batch: allTransactions
      }).then(response=>{
        allTransactions = []
      })
                }
              })
          }
      this.nodeBillingRun(date);
        });
    },
    async approveBas(setDate) {
      console.log("BAS Billing");
      console.log(setDate)
      this.snackbar=true
      this.text="BAS Billing"
      let date = new Date(setDate);
      // let setDate = new Date(this.setDate);
      await Api()
        .get("/locationNetworks/allActiveBilling")
        .then(async response => {
          this.allNetworks = response.data;
          for (let i = 0; i < this.allNetworks.length; i++) {
            if (
              this.allNetworks[i].lineRentalIncluded &&
              this.allNetworks[i].networkStatus === "Live"
            ) {
              if (this.allNetworks[i].hasSingleLineRentalCustomer) {
                if (this.allNetworks[i].locations&&this.allNetworks[i].locations.length > 0) {
                  for (
                    let x = 0;
                    x < this.allNetworks[i].locations.length;
                    x++
                  ) {
                    if (this.allNetworks[i].locations[x].equipmentInstalled) {
                      await this.transactionPost.push({
                        date: setDate,
                        description: "Line Rental: BAS",
                        xeroCode: "1",
                        amount: this.allNetworks[i].residentialLineRentalValue,
                        isRecurring: true,
                        supplierId: null,
                        organisationId: this.$store.state.currentOrg.org.id,
                        customerOrganisationId: this.allNetworks[i].customerOrganisationId,
                        transactionType: "Sales",
                        batchNumber: this.billingBatchNumber.toString(),
                        locationId: this.allNetworks[i].locations[x].id,
                        locationNetworkId: this.allNetworks[i].locations[x]
                          .locationNetworkId,
                        locationNodeId: this.allNetworks[i].locationNodeId,
                        switchingCentreId: this.allNetworks[i].locationNode
                          .switchingCentreId,
                        loanAccountCustomerId: null,
                        upstreamTransactionId: null,
                        isActive: true,
                        isDeleted: false
                      })
                     
                      // console.log("BAS Billed: "+this.allNetworks[i].locations[x].locationDescription)
                    }
                  }
                }
              } else {
                await Api()
                  .get(
                    "/locationNetworkSubComplex/byNetwork/" +
                      this.allNetworks[i].id
                  )
                  .then(async response => {
                    let subComplexes = response.data;
                    for (let y = 0; y < subComplexes.length; y++) {
                      await Api()
                        .get(
                          "/Locations/subcomplex/" +
                            this.allNetworks[i].id +
                            "/" +
                            subComplexes[y].id
                        )
                        .then(async result => {
                          let locations = result.data;
                          for (let a = 0; a < locations.length; a++) {
                            if (locations[a].equipmentInstalled) {
                              await this.transactionPost.push({
                                date: setDate,
                                description: "Line Rental: BAS",
                                xeroCode: "1",
                                amount: this.allNetworks[i].residentialLineRentalValue,
                                isRecurring: true,
                                organisationId: this.$store.state.currentOrg.org.id,
                                supplierOrganisationId: null,
                                customerOrganisationId: subComplexes[y].customerOrganisationId,
                                transactionType: "Sales",
                                batchNumber: this.billingBatchNumber.toString(),
                                locationId: locations[a].id,
                                locationNetworkId:
                                  locations[a].locationNetworkId,
                                locationNodeId:
                                  locations[a].locationNetwork.locationNodeId,
                                switchingCentreId:
                                  locations[a].locationNetwork.locationNode
                                    .switchingCentreId,
                                loanAccountCustomerId: null,
                                upstreamTransactionId: null,
                                isActive: true,
                                isDeleted: false
                              })
                              
                            }
                          }
                        });
                    }
                  });
              }
            }
          }
        });
        await Api()
      .post('/transactions/bulk',{
        batch: this.transactionPost
      }).then(response=>{
        if(response.status===200){
          this.transactionPost=[]
        }
      })
      await this.networkBillingRun(date);
    },
    async approveVas(setDate, batchNumber) {
      console.log('VAS Billing')
      console.log(setDate)
      this.snackbar=true
      this.text="VAS Billing"
      this.daysInCurrentMonth = Math.round(
        Math.abs(new Date(this.endDay).getTime() - new Date(this.startDay).getTime()) / 86400000
      );
      for (var i = 0; i < this.billingData.length; i++) {
        let onceOffBilled = this.billingData[i].onceOff
        let bas=0
        if(this.billingData[i].packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential'){
           bas = this.billingData[i].location.locationNetwork.residentialLineRentalValue;
        } else if(this.billingData[i].packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business'){
           bas = this.billingData[i].location.locationNetwork.businessLineRentalValue;
        } 
        this.billedDays = Math.round(
        Math.abs(new Date(this.billingData[i].endDate).getTime() - new Date(this.billingData[i].startDate).getTime()) / 86400000
      );
      if(this.billedDays > this.daysInCurrentMonth){
        this.billedDays = this.daysInCurrentMonth
      }
        let networkManagementFee = 0;
        let calculatedBillableAmount = this.billingData[i].prorata
        let vas = 0;

        let prorataPercent = this.billedDays / this.daysInCurrentMonth;

        if (this.billingData[i].location.locationNetwork.lineRentalIncluded) {
          bas = bas * prorataPercent;
          vas = calculatedBillableAmount;
        } else {
          bas = bas * prorataPercent;
          vas = calculatedBillableAmount - bas;
        }
        let date = new Date(setDate);
        await this.transactionPost.push({
          date: setDate,
          description: "Data Package: VAS",
          xeroCode: "203",
          amount: vas,
          organisationId: this.$store.state.currentOrg.org.id,
          customerOrganisationId: this.billingData[i].packagesIsp.customerOrganisationId,
          isRecurring: true,
          batchNumber: batchNumber.toString(),
          transactionType: "Sales",
          locationId: this.billingData[i].locationId,
          locationNetworkId: this.billingData[i].location.locationNetworkId,
          locationNodeId: this.billingData[i].location.locationNetwork
            .locationNodeId,
          switchingCentreId: this.billingData[i].location.locationNetwork
            .locationNode.switchingCentreId,
          loanAccountCustomerId: null,
          upstreamTransactionId: null,
          serviceAccountId: this.billingData[i].id,
          isActive: true,
          isDeleted: false
        })

        if (!this.billingData[i].location.locationNetwork.lineRentalIncluded) {
          await this.transactionPost.push({
            date: setDate,
            description: "Line Rental: BAS",
            xeroCode: "203",
            amount: bas,
            isRecurring: true,
            batchNumber: batchNumber.toString(),
            organisationId: this.$store.state.currentOrg.org.id,
            customerOrganisationId: this.billingData[i].packagesIsp.customerOrganisationId,
            transactionType: "Sales",
            locationId: this.billingData[i].locationId,
            locationNetworkId: this.billingData[i].location.locationNetworkId,
            locationNodeId: this.billingData[i].location.locationNetwork
              .locationNodeId,
            switchingCentreId: this.billingData[i].location.locationNetwork
              .locationNode.switchingCentreId,
            loanAccountCustomerId: null,
            upstreamTransactionId: null,
            serviceAccountId: this.billingData[i].id,
            isActive: true,
            isDeleted: false
          })
        }
        if (this.billingData[i].onceOff !== 0) {
          await this.transactionPost.push({
            date: setDate,
            description: "Data Activation Fee",
            xeroCode: "205",
            amount: this.billingData[i].onceOff,
            isRecurring: false,
            transactionType: "Sales",
            batchNumber: batchNumber.toString(),
            organisationId: this.$store.state.currentOrg.org.id,
            customerOrganisationId: this.billingData[i].packagesIsp.customerOrganisationId,
            locationId: this.billingData[i].locationId,
            locationNetworkId: this.billingData[i].location.locationNetworkId,
            locationNodeId: this.billingData[i].location.locationNetwork
              .locationNodeId,
            switchingCentreId: this.billingData[i].location.locationNetwork
              .locationNode.switchingCentreId,
            upstreamTransactionId: null,
            serviceAccountId: this.billingData[i].id,
            isActive: true,
            isDeleted: false
          })
        }
        if (
          this.billingData[i].location.locationNetwork
            .fibreFarmerLocationNetworks !== null
        ) {
          for (
            let x = 0;
            x <
            this.billingData[i].location.locationNetwork
              .fibreFarmerLocationNetworks.length;
            x++
          ) {
            if(this.billingData[i].location.locationNetwork
                .fibreFarmerLocationNetworks[x].isActive&&!this.billingData[i].location.locationNetwork
                .fibreFarmerLocationNetworks[x].isDeleted){
                  if (
              !this.billingData[i].location.locationNetwork
                .fibreFarmerLocationNetworks[x].isInvestor
            ) {
              await this.transactionPost.push({
                date: date,
                description:
                  this.billingData[i].location.locationNetwork
                    .fibreFarmerLocationNetworks[x].type + " Commission",
                xeroCode: "1",
                amount:
                  (vas > this.billingData[i].layerTwoProrata)?((vas - this.billingData[i].layerTwoProrata) *
                  (this.billingData[i].location.locationNetwork
                    .fibreFarmerLocationNetworks[x]
                    .vasProfitPercentage /
                    100)):0,
                isRecurring: true,
                transactionType: "Cost of Sales",
                organisationId: this.$store.state.currentOrg.org.id,
                supplierOrganisationId: this.billingData[i].location.locationNetwork
                  .fibreFarmerLocationNetworks[x].customerOrganisationId,
                batchNumber: batchNumber.toString(),
                locationId: this.billingData[i].locationId,
                locationNetworkId: this.billingData[i].location
                  .locationNetworkId,
                locationNodeId: this.billingData[i].location.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.billingData[i].location.locationNetwork
                  .locationNode.switchingCentreId,
                loanAccountCustomerId: null,
                upstreamTransactionId: null,
                serviceAccountId: this.billingData[i].id,
                isActive: true,
                isDeleted: false})
             
            } else {
              await this.transactionPost.push({
                date: setDate,
                description: "Network Management Fee",
                xeroCode: "1",
                amount:
                  prorataPercent *
                  this.billingData[i].location.locationNetwork
                    .fibreFarmerLocationNetworks[x]
                    .basExpense,
                isRecurring: true,
                transactionType: "Sales",
                organisationId: this.$store.state.currentOrg.org.id,
                customerOrganisationId: this.billingData[i].location.locationNetwork
                  .fibreFarmerLocationNetworks[x].customerOrganisationId,
                batchNumber: batchNumber.toString(),
                locationId: this.billingData[i].locationId,
                locationNetworkId: this.billingData[i].location
                  .locationNetworkId,
                locationNodeId: this.billingData[i].location.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.billingData[i].location.locationNetwork
                  .locationNode.switchingCentreId,
                upstreamTransactionId: null,
                serviceAccountId: this.billingData[i].id,
                isActive: true,
                isDeleted: false
              })
              await this.transactionPost.push({
                date: setDate,
                description: "Network Management Fee",
                xeroCode: "1",
                amount:
                  prorataPercent *
                  this.billingData[i].location.locationNetwork
                    .fibreFarmerLocationNetworks[x]
                    .basExpense,
                isRecurring: true,
                transactionType: "Cost of Sales",
                organisationId: this.billingData[i].location.locationNetwork
                  .fibreFarmerLocationNetworks[x].customerOrganisationId,
                  supplierOrganisationId: this.$store.state.currentOrg.org.id,
                batchNumber: batchNumber.toString(),
                locationId: this.billingData[i].locationId,
                locationNetworkId: this.billingData[i].location
                  .locationNetworkId,
                locationNodeId: this.billingData[i].location.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.billingData[i].location.locationNetwork
                  .locationNode.switchingCentreId,
                upstreamTransactionId: null,
                serviceAccountId: this.billingData[i].id,
                isActive: true,
                isDeleted: false
              })
              await this.transactionPost.push({
                date: setDate,
                description: "Data Package Sales",
                xeroCode: "203",
                amount: bas + (vas - this.billingData[i].layerTwoProrata) ,
                isRecurring: true,
                transactionType: "Sales",
                organisationId: this.billingData[i].location.locationNetwork
                  .fibreFarmerLocationNetworks[x].customerOrganisationId,
                  customerOrganisationId: this.$store.state.currentOrg.org.id,
                batchNumber: batchNumber.toString(),
                locationId: this.billingData[i].locationId,
                locationNetworkId: this.billingData[i].location
                  .locationNetworkId,
                locationNodeId: this.billingData[i].location.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.billingData[i].location.locationNetwork
                  .locationNode.switchingCentreId,
                upstreamTransactionId: null,
                serviceAccountId: this.billingData[i].id,
                isActive: true,
                isDeleted: false
              })
              // if(this.billingData[i].onceOff>0){
              //   await this.transactionPost.push({
              //   date: date,
              //   description: "Data Activation Fee Sales",
              //   xeroCode: "205",
              //   amount: this.billingData[i].onceOff,
              //   isRecurring: false,
              //   transactionType: "Sales",
              //   organisationId: this.billingData[i].location.locationNetwork
              //     .fibreFarmerLocationNetworks[x].customerOrganisationId,
              //     customerOrganisationId: this.$store.state.currentOrg.org.id,
              //   batchNumber: batchNumber.toString(),
              //   locationId: this.billingData[i].locationId,
              //   locationNetworkId: this.billingData[i].location
              //     .locationNetworkId,
              //   locationNodeId: this.billingData[i].location.locationNetwork
              //     .locationNodeId,
              //   switchingCentreId: this.billingData[i].location.locationNetwork
              //     .locationNode.switchingCentreId,
              //   upstreamTransactionId: null,
              //   serviceAccountId: this.billingData[i].id,
              //   isActive: true,
              //   isDeleted: false
              // })
              // }
              
              await this.transactionPost.push({
                date: setDate,
                description: "Data Package COS",
                xeroCode: "1",
                amount: bas + (vas - this.billingData[i].layerTwoProrata) ,
                isRecurring: true,
                transactionType: "Cost of Sales",
                supplierOrganisationId: this.billingData[i].location.locationNetwork
                  .fibreFarmerLocationNetworks[x].customerOrganisationId,
                  organisationId: this.$store.state.currentOrg.org.id,
                batchNumber: batchNumber.toString(),
                locationId: this.billingData[i].locationId,
                locationNetworkId: this.billingData[i].location
                  .locationNetworkId,
                locationNodeId: this.billingData[i].location.locationNetwork
                  .locationNodeId,
                switchingCentreId: this.billingData[i].location.locationNetwork
                  .locationNode.switchingCentreId,
                upstreamTransactionId: null,
                serviceAccountId: this.billingData[i].id,
                isActive: true,
                isDeleted: false
              })
              // if(this.billingData[i].onceOff>0){
              //   await this.transactionPost.push({
              //   date: date,
              //   description: "Data Activation Fee COS",
              //   xeroCode: "1",
              //   amount: this.billingData[i].onceOff,
              //   isRecurring: false,
              //   transactionType: "Cost of Sales",
              //   supplierOrganisationId: this.billingData[i].location.locationNetwork
              //     .fibreFarmerLocationNetworks[x].customerOrganisationId,
              //     organisationId: this.$store.state.currentOrg.org.id,
              //   batchNumber: batchNumber.toString(),
              //   locationId: this.billingData[i].locationId,
              //   locationNetworkId: this.billingData[i].location
              //     .locationNetworkId,
              //   locationNodeId: this.billingData[i].location.locationNetwork
              //     .locationNodeId,
              //   switchingCentreId: this.billingData[i].location.locationNetwork
              //     .locationNode.switchingCentreId,
              //   upstreamTransactionId: null,
              //   serviceAccountId: this.billingData[i].id,
              //   isActive: true,
              //   isDeleted: false
              // })
              // }
              
            }
                }
            
          }
        }
      }
      await Api()
      .post('/transactions/bulk',{
        batch: this.transactionPost
      }).then(response=>{
        if(response.status===200){
          this.transactionPost=[]
        }
      })
    },
    async approve() {
      this.transactionPost=[]
      if(this.authCreate(this.$store.state.currentRoute)){
      this.billingRunLoading = true;
      let selectedDate = new Date();
      // selectedDate.setHours(0,0,0,0)
      (this.startDay = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth() - 1,
        26
      )),
        (this.endDay = new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth() + 1,
          25
        ));
      this.dateStamp = new Date().getMonth()+'-'+new Date().getFullYear()
      // let setDate = new Date(this.$route.query.billingDate);
      this.billingBatchNumber = Math.floor(Math.random() * 1000000000000) + 1;
      await this.approveVas(new Date(), this.billingBatchNumber);
      await this.approveBas(new Date());
    }}
  }
};
</script>
